import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.review.needed');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-review-needed',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.review.needed/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageReviewNeededComponent implements OnInit {
    public loading: boolean = true;
    public documents: any[] = [];
    public total: number = 0;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");
        await this.load();
    }

    public async load() {
        this.loading = true;
        await this.service.render();

        const { code, data } = await wiz.call("list");
        if (code === 200) {
            this.documents = data.documents || [];
            this.total = data.total || this.documents.length;
        }

        this.loading = false;
        await this.service.render();
    }

    public get hasDocuments(): boolean {
        return this.documents.length > 0;
    }

    public get documentedReasonCount(): number {
        return this.documents.filter((doc: any) => doc.has_reason).length;
    }

    public statusLabel(status: string): string {
        if (status === 'failed') return '검토 필요';
        if (status === 'processing') return '분석 중';
        if (status === 'pending') return '대기';
        if (status === 'completed') return '완료';
        return status || '-';
    }

    public progressLabel(doc: any): string {
        const progress = doc.progress || 0;
        if (!progress) return '진행률 없음';
        return `${progress}% 진행 후 중단`;
    }

    public reasonToneClass(doc: any): string {
        if (doc.has_reason) return 'bg-red-50 text-red-700 dark:bg-red-950/40 dark:text-red-300';
        return 'bg-amber-50 text-amber-700 dark:bg-amber-950/40 dark:text-amber-300';
    }
}

export default PageReviewNeededComponent;